const REFERRAL_KEY = 'platechase_referral';

export function storeReferralCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) sessionStorage.setItem(REFERRAL_KEY, ref.trim());
  } catch {
    /* ignore */
  }
}

export function getStoredReferralCode() {
  try {
    return sessionStorage.getItem(REFERRAL_KEY) || null;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode() {
  try {
    sessionStorage.removeItem(REFERRAL_KEY);
  } catch {
    /* ignore */
  }
}
